/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Reassign_Notice_BodyInputs */

const en_ticket_reassign_notice_body = /** @type {(inputs: Ticket_Reassign_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The list below may change, because tickets may be reassigned from one field engineer to another up to 19:00. Wait for the email the Service Desk sends every evening to tell you the assignment is finished.`)
};

const ja_ticket_reassign_notice_body = /** @type {(inputs: Ticket_Reassign_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下のリストは変更される場合があります。19時まで、チケットが別のフィールドエンジニアに再割り当てされる可能性があります。割り当ての完了は、サービスデスクが毎晩送信するメールでお知らせしますので、それをお待ちください。`)
};

const fr_ticket_reassign_notice_body = /** @type {(inputs: Ticket_Reassign_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La liste ci-dessous peut changer, car des tickets peuvent être réassignés d’un technicien de terrain à un autre jusqu’à 19 h. Attendez l’e-mail que le Service Desk envoie chaque soir pour vous indiquer que l’affectation est terminée.`)
};

const de_ticket_reassign_notice_body = /** @type {(inputs: Ticket_Reassign_Notice_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die folgende Liste kann sich ändern, da Tickets bis 19:00 Uhr von einem Servicetechniker einem anderen zugewiesen werden können. Warten Sie auf die E-Mail, die der Service Desk jeden Abend sendet, um Ihnen mitzuteilen, dass die Zuweisung abgeschlossen ist.`)
};

/**
* | output |
* | --- |
* | "The list below may change, because tickets may be reassigned from one field engineer to another up to 19:00. Wait for the email the Service Desk sends every ..." |
*
* @param {Ticket_Reassign_Notice_BodyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_reassign_notice_body = /** @type {((inputs?: Ticket_Reassign_Notice_BodyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Reassign_Notice_BodyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_reassign_notice_body(inputs)
	if (locale === "ja") return ja_ticket_reassign_notice_body(inputs)
	if (locale === "fr") return fr_ticket_reassign_notice_body(inputs)
	return de_ticket_reassign_notice_body(inputs)
});